module.exports = __webpack_public_path__ + "img/32_4.99fead8e.png";